var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorDiversity160)",
    d: "M12.495 8.831a1 1 0 0 0-1 0l-1.99 1.15a1 1 0 0 0-.5.865v2.298a1 1 0 0 0 .5.866l1.99 1.149a1 1 0 0 0 1 0l1.99-1.15a1 1 0 0 0 .5-.865v-2.298a1 1 0 0 0-.5-.866z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorDiversity161)",
    d: "M4 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorDiversity162)",
    d: "M10.5 1A1.5 1.5 0 0 0 9 2.5v3A1.5 1.5 0 0 0 10.5 7h3A1.5 1.5 0 0 0 15 5.5v-3A1.5 1.5 0 0 0 13.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorDiversity163)",
    d: "M2.913 1.674a1.214 1.214 0 0 1 2.174 0l1.78 3.537C7.277 6.03 6.688 7 5.778 7H2.22c-.91 0-1.5-.97-1.087-1.79z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorDiversity160",
    x1: 5.517,
    x2: 13.624,
    y1: 5.949,
    y2: 14.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d17c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22918b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorDiversity161",
    x1: 1,
    x2: 7,
    y1: 9,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0fafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorDiversity162",
    x1: 6.5,
    x2: 13.875,
    y1: -2,
    y2: 7.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcd0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe8401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorDiversity163",
    x1: 1.214,
    x2: 5.355,
    y1: 2.125,
    y2: 6.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f24a9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7257d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.850426706b3f9bf7dba699eefc2d6127.svg";
export { ForwardRef as ReactComponent };